import React from 'react';

import MoneyAmount from '@/shared/ui/components/money-amount';
import type { Currency } from '@/types';

interface DeclineAmountDisplayProps {
  amount: { amount: number; currency: string; amountMax?: number } | null;
  currency: string | Currency;
  language: string;
  className?: string;
  amountClassName?: string;
  currencyClassName?: string;
}

export function DeclineAmountDisplay({
  amount,
  currency,
  language,
  className,
  amountClassName,
  currencyClassName,
}: DeclineAmountDisplayProps): React.JSX.Element {
  if (!amount) {
    return (
      <span
        className={['text-[#7E82AD]', className, amountClassName]
          .filter(Boolean)
          .join(' ')}
        aria-hidden
      >
        —
      </span>
    );
  }

  return (
    <MoneyAmount
      amount={amount.amount}
      currency={amount.currency || currency}
      language={language}
      className={className}
      amountClassName={amountClassName}
      currencyClassName={currencyClassName}
    />
  );
}
